<template>
  <div class="container-fluid">
    <v-card
      color="red"
      flat
      tile
      class="d-print-none"
    >
      <v-toolbar dense
                 src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg"
      >
        <v-spacer></v-spacer>
        <v-btn
          @click="exportExcel"
          outlined
          color="error"
          v-if="toolbarButtonsVisible"
        >
          Excel export
        </v-btn>
        <v-btn
          @click="exportPdf"
          outlined
          color="error"
          v-if="toolbarButtonsVisible"
        >
          PDF export
        </v-btn>
      </v-toolbar>
    </v-card>
    <v-data-table
      ref="ordersTable"
      :loading="loading"
      :headers="headers"
      :items="ordersItemsFiltered"
      item-key="uID"
      sort-by="orderNumber"
      class="elevation-1 d-print-block"
      :sort-desc="true"
      :search="search"
      locale="cs"
      :items-per-page="-1"
    >
      <template v-slot:top>
        <v-toolbar  flat color="white">
          <v-toolbar-title>Objednávky</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer>Výpis</v-spacer>
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="orderDate"
                label="Filtr Data"
                hide-details
                single-line
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="orderDate"
              @input="menu2 = false"
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>
          <v-select
            :items="institutions"
            item-value="id"
            item-text="name"
            v-model="selectedInstitutionId"
            label="Filtr instituce"
            single-line
            deletable-chips
            small-chips
            hide-details
          ></v-select>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Vyhledávání"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.orderDay.order.description="{ item }">
        <v-chip
          v-if="item.orderDay.order.description != null"
          color="green"
          dark
        >
          {{ item.orderDay.order.description }}
        </v-chip>
      </template>
      <template v-slot:item.orderDay.order.customPackaging="{ item }">
        <v-chip
          v-if="item.orderDay.order.customPackaging === 1"
          color="orange"
          dark
        >
          VN
        </v-chip>
        <v-chip
          v-else
          color="green"
          dark
        >
          SB
        </v-chip>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ExcelJS from 'exceljs'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

export default {
  Name: 'OrderItems',
  data () {
    return {
      orderDate: new Date().toISOString().substr(0, 10),
      menu2: false,
      menu: false,
      loading: true,
      institutions: [],
      toolbarButtonsVisible: false,
      search: '',
      singleExpand: true,
      headers: [
        { text: 'Položka', value: 'item.name', align: 'start', sortable: true },
        { text: 'Typ', value: 'item.foodTypes', align: 'start', sortable: true },
        { text: 'Počet', value: 'quantity' },
        { text: 'Jídelníček', value: 'orderDay.order.diet.name' },
        { text: 'Poznámka', value: 'orderDay.order.description' },
        { text: 'Denní doba', value: 'timeId' },
        { text: 'Jméno', value: 'orderDay.order.user.fullName' },
        { text: 'Strávníci', value: 'orderDay.order.boarderNames' },
        { text: 'Číslo objednávky', value: 'orderDay.orderId' },
        { text: 'Rozvoz', value: 'orderDay.order.deliveryType' },
        { text: 'Balení', value: 'orderDay.order.customPackaging' },
        { text: 'Datum vytvoření', value: 'orderDay.order.orderDate' },
        { text: 'E-mail', value: 'orderDay.order.user.email' },
        { text: 'Telefon', value: 'orderDay.order.user.phone1' }
      ],
      headersPrint: [
        { text: 'Položka', value: 'item.name', align: 'start', sortable: true },
        { text: 'Počet', value: 'quantity' },
        { text: 'Jídelníček', value: 'orderDay.order.diet.name' },
        { text: 'Vlastní nádoba', value: 'orderDay.order.customPackaging' },
        { text: 'Jméno', value: 'orderDay.order.user.fullName' },
        { text: 'Strávníci', value: 'orderDay.order.boarderNames' },
        { text: 'Poznámka', value: 'orderDay.order.description' },
        { text: 'Denní doba', value: 'timeId' }
      ],
      selectedInstitutionId: null,
      orderItemsAll: [],
      exportType: 'pdf',
      exportDialog: false
    }
  },
  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.getOrderItems()
      this.getInstitutions()
    },
    getOrderItems () {
      this.loading = true
      this.toolbarButtonsVisible = false
      this.$http.post('admin/order-items', { date: this.orderDate })
        .then(response => {
          this.orderItemsAll = this.keysToCamelCase(response.data).map(i => {
            if (i.orderDay.order.user) {
              i.orderDay.order.user.fullName = `${i.orderDay.order.user.firstName} ${i.orderDay.order.user.lastName}`
            }
            i.item.foodTypes = i.item.foodTypes
              .map(foodTypes => foodTypes.name)
              .join(', ')
            i.orderDay.order.boarderNames = []
            i.orderDay.order.boarders
              .forEach(boarder => {
                i.orderDay.order.boarderNames.push(`${boarder.firstName} ${boarder.lastName}`)
                // console.log(boarder)
              })
            i.orderDay.order.boarderNames = i.orderDay.order.boarderNames.toString()
            switch (i.timeId) {
              case 1: i.timeId = 'Snídaně'; break
              case 2: i.timeId = 'Dopolední svačina'; break
              case 3: i.timeId = 'Oběd'; break
              case 4: i.timeId = 'Odpolední svačina'; break
              case 5: i.timeId = 'Večeře'; break
              case 6: i.timeId = 'Druhá večeře'; break
            }
            return i
          }).reverse()
          this.loading = false
          this.toolbarButtonsVisible = true
        })
        .catch(err => {
          console.log(err)
        })
    },
    getInstitutions () {
      this.$http.get('/admin/institutions')
        .then(response => {
          this.institutions = this.keysToCamelCase(response.data)
        })
    },
    exportExcel () {
      const workbook = new ExcelJS.Workbook()
      const sheet = workbook.addWorksheet('Položky objednávek')
      sheet.mergeCells('A1:C1')
      sheet.getCell('A1').value = 'Položky objednávek'

      const now = new Date()
      const nowCzDate = now.toLocaleDateString('cs-CZ', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
      const nowCzTime = now.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
      sheet.mergeCells('A2:C2')
      sheet.getCell('A2').value = `${nowCzDate} ${nowCzTime}`

      const headers = this.headersPrint.map(h => h.text)
      sheet.getRow(4).values = headers
      sheet.columns = [
        { key: 'name', width: 35 },
        { key: 'quantity' },
        { key: 'dietName', width: 20 },
        { key: 'customPackaging', width: 20 },
        { key: 'fullName', width: 20 },
        { key: 'boarders', width: 25 },
        { key: 'description', width: 25 },
        { key: 'timeId', width: 25 }
      ]

      this.ordersItemsFiltered.forEach((item, index) => {
        sheet.getRow(5 + index).values = {
          name: item.item.name,
          foodType: item.item.foodTypes,
          quantity: item.quantity,
          dietName: item.orderDay.order.diet.name,
          description: item.orderDay.order.description,
          fullName: item.orderDay.order.user.fullName,
          delivery: item.orderDay.order.deliveryType,
          state: item.orderDay.order.state,
          date: item.orderDay.order.orderDate,
          email: item.orderDay.order.user.email,
          phone: item.orderDay.order.user.phone1,
          orderId: item.orderDay.orderId,
          customPackaging: item.orderDay.order.customPackaging,
          boarders: item.orderDay.order.boarderNames,
          timeType: item.orderDay.order,
          timeId: item.timeId
        }
      })
      sheet.eachRow(row => {
        row.eachCell(cell => {
          cell.alignment = { vertical: 'middle', horizontal: 'right', wrapText: true }
        })
      })
      workbook.xlsx.writeBuffer().then(data => {
        const blob = new Blob([data],
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = 'export_polozky_objednavek.xlsx'
        anchor.click()
        window.URL.revokeObjectURL(url)
      })
    },
    exportPdf () {
      const now = new Date()
      const nowCzDate = now.toLocaleDateString('cs-CZ', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
      const nowCzTime = now.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
      pdfMake.vfs = pdfFonts.pdfMake.vfs
      const tableDelivery = this.ordersItemsFiltered.map(item => {
        return [
          item.item.name,
          item.item.foodTypes,
          item.quantity,
          item.orderDay.order.diet.name,
          item.orderDay.order.description,
          item.orderDay.order.user.fullName,
          item.orderDay.orderId,
          item.orderDay.order.deliveryType,
          item.orderDay.order.state,
          item.orderDay.order.orderDate,
          item.orderDay.order.user.email,
          item.orderDay.order.user.phone1
        ]
      })
      const docDefinition = {
        pageOrientation: 'landscape',
        content: [
          {
            text: 'Položky objednávek'
          },
          {
            text: `${nowCzDate} ${nowCzTime}`
          },
          {
            table: {
              body: [
                this.headers.map(h => h.text),
                ...tableDelivery
              ]
            }
          }
        ]
      }
      pdfMake.createPdf(docDefinition).download('export_polozky_objednavek')
    }
  },
  watch: {
    orderDate () {
      this.getOrderItems()
    }
  },
  computed: {
    ordersItemsFiltered () {
      return this.orderItemsAll.filter(item => {
        if (this.selectedInstitutionId) {
          return item.orderDay.order.institutionId === this.selectedInstitutionId
        } else { // return all if selectedInstitutionId is falsy
          return true
        }
      })
    }
  }
}
</script>

<style scoped>
.export-date{

}
>>>tbody td:nth-child(5) .v-chip__content{
  word-wrap: break-word;
  white-space: normal;
}

>>>tbody td:nth-child(5) .v-chip{
  height: auto;
}
.v-data-table {
  max-width: 100%;
  overflow-x: auto !important;
}
</style>
